import React from 'react';
import Img from 'gatsby-image';
import './picture.css';

const Picture = ({
  id,
  title,
  width,
  height,
  price,
  image,
  shopLink,
  selected,
  onClick
}) => {
  return (
    <div className="picture">
      <Img sizes={image.sizes} />
      <div className="dots" onClick={() => onClick(id)}>
        ...
      </div>
      {selected && (
        <div className="info">
          <div className="title">
            {[
              title,
              width && height ? `${width}x${height}cm` : null,
              price ? `${price}€` : null
            ]
              .filter(d => !!d)
              .join(', ')}
          </div>
          {shopLink && (
            <div>
              <a target="_blank" rel="noopener noreferrer" href={shopLink}>
                Acheter une reproduction
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Picture;

export const query = graphql`
  fragment PictureFragment on DatoCmsPicture {
    id
    title
    position
    price
    width
    height
    shopLink
    image {
      sizes(maxWidth: 740, imgixParams: { fm: "jpg", auto: "compress" }) {
        ...GatsbyDatoCmsSizes_noBase64
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/picture.js